import React from 'react'
import { Box } from "@mui/material"

import { AppRetailerBlock } from "@components/DataBlocks/index"
import { AppButtonIcon } from "@components/@base"
import { sitesModalData } from "@signals"
import AppMoreCount from "./MoreCount"


// compact: the first site on one line and "+N" for the rest (they open in "Show all")
export default function AppRetailerBlockContainer({ rows, compact = false }) {
	if (compact) return <Box sx={{ display: "flex", alignItems: "center" }}>
		{!!rows?.[0] && <AppRetailerBlock retailer={rows[0].name} country={rows[0].market}/>}
		<AppMoreCount count={(rows?.length || 0) - 1} onClick={() => sitesModalData.value = rows}/>
	</Box>

	return <Box sx={{ display: "flex", alignItems: "start", justifyContent: "start", flexDirection: "column" }}>
		{rows?.map(({ name, market }, idx) => {
			if (idx < 10) {
				return <AppRetailerBlock
					key={idx}
					retailer={name}
					country={market}
				/>
			}
		})}
		{rows?.length > 10 && <AppButtonIcon
			onClick={() => sitesModalData.value = rows}
			iconWeight="regular"
			icon="plus"
			tooltip={`Show all`}
			sx={{ color: "info.main", pl: .2 }}
		/>}
	</Box>
}